import React from 'react'

import {
  Box,
  Display,
  FlexDirection,
  Heading2,
  JustifyContent,
  TextAlign,
} from '@gousto-internal/citrus-react'

import { TestimonialCard } from '../../../../components'
import { TESTIMONIALS_SECTION } from './config'

export function TestimonialSection() {
  return (
    <Box paddingH={[8, 20]} paddingV={16}>
      <Box paddingBottom={6}>
        <Heading2 textAlign={[TextAlign.Left, null, null, TextAlign.Center]}>
          {TESTIMONIALS_SECTION.heading}
        </Heading2>
      </Box>

      <Box
        display={Display.Flex}
        flexDirection={[FlexDirection.Column, null, null, FlexDirection.Row]}
        justifyContent={[JustifyContent.SpaceEvenly, JustifyContent.Center]}
        gap={[6, 8]}
      >
        {TESTIMONIALS_SECTION.testimonials.map((testimonial) => (
          <Box flexBasis={[null, null, null, '33%']} key={testimonial.author}>
            <TestimonialCard quote={testimonial.quote} author={testimonial.author} />
          </Box>
        ))}
      </Box>
    </Box>
  )
}
